// Do not edit directly, this file was auto-generated.
// Regenerate: npm run generate:tokens
export var Foreground;
(function (Foreground) {
    Foreground["ExpandedGroup"] = "fg-expanded-group";
    Foreground["Hint"] = "fg-hint";
    Foreground["LineIconButton"] = "fg-line-icon-button";
    Foreground["Long"] = "fg-long";
    Foreground["MdHistogramVol"] = "fg-md-histogram-vol";
    Foreground["MdPriceLevel"] = "fg-md-price-level";
    Foreground["Negative"] = "fg-negative";
    Foreground["Plate"] = "fg-plate";
    Foreground["Positive"] = "fg-positive";
    Foreground["Primary"] = "fg-primary";
    Foreground["PrimaryData"] = "fg-primary-data";
    Foreground["Secondary"] = "fg-secondary";
    Foreground["Short"] = "fg-short";
    Foreground["Toggle"] = "fg-toggle";
    Foreground["Tooltip"] = "fg-tooltip";
})(Foreground || (Foreground = {}));
export var Background;
(function (Background) {
    Background["Ask"] = "bg-ask";
    Background["Bid"] = "bg-bid";
    Background["Buy"] = "bg-buy";
    Background["High"] = "bg-high";
    Background["Input"] = "bg-input";
    Background["Limit"] = "bg-limit";
    Background["LineIconButton"] = "bg-line-icon-button";
    Background["Low"] = "bg-low";
    Background["MdPriceLvl1"] = "bg-md-price-lvl-1";
    Background["MdPriceLvl2"] = "bg-md-price-lvl-2";
    Background["MdPriceLvl3"] = "bg-md-price-lvl-3";
    Background["MdPriceLvl4"] = "bg-md-price-lvl-4";
    Background["MdPriceLvl5"] = "bg-md-price-lvl-5";
    Background["Mid"] = "bg-mid";
    Background["Outline"] = "bg-outline";
    Background["Primary"] = "bg-primary";
    Background["PutCall"] = "bg-put-call";
    Background["Secondary"] = "bg-secondary";
    Background["Sell"] = "bg-sell";
    Background["Stop"] = "bg-stop";
    Background["Surface"] = "bg-surface";
    Background["TableLine"] = "bg-table-line";
    Background["Tooltip"] = "bg-tooltip";
})(Background || (Background = {}));
export var Stroke;
(function (Stroke) {
    Stroke["BottomTab"] = "stroke-bottom-tab";
    Stroke["ChartGrid"] = "stroke-chart-grid";
    Stroke["EditableCell"] = "stroke-editable-cell";
    Stroke["General"] = "stroke-general";
    Stroke["HeaderCell"] = "stroke-header-cell";
    Stroke["Input"] = "stroke-input";
    Stroke["OutlineBuy"] = "stroke-outline-buy";
    Stroke["OutlineSell"] = "stroke-outline-sell";
})(Stroke || (Stroke = {}));
